module.exports = __webpack_public_path__ + "static/img/Fitria Morouwsky-full.3b86f08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/full/Fitria Morouwsky-full.png
// module id = YpxD
// module chunks = 1